import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faMapMarkerAlt, faEnvelopeSquare, faPhoneSquare, faPhoneSquareAlt } from '@fortawesome/free-solid-svg-icons'
import { faTwitterSquare, faGithubSquare, faLinkedin} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './assets/css/App.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueScrollTo from 'vue-scrollto'

library.add(faBars,faMapMarkerAlt,faTwitterSquare, faGithubSquare, faLinkedin, faEnvelopeSquare, faPhoneSquare, faPhoneSquareAlt)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueScrollTo)

Vue.config.productionTip = false

new Vue({
  created () {
    AOS.init({
      duration: 500, // values from 0 to 3000, with step 50ms
      once: false,
    })
  },
  render: h => h(App),
}).$mount('#app')
